import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Zap, Fuel, BadgeCheck, ShieldCheck, Star, Clock, Leaf, Wrench } from "lucide-react";

export const BENEFIT_ICONS = {
  zap: Zap,
  fuel: Fuel,
  "badge-check": BadgeCheck,
  shield: ShieldCheck,
  star: Star,
  clock: Clock,
  leaf: Leaf,
  wrench: Wrench,
};

export const BENEFIT_ICON_LABELS = {
  zap: "ელვა (ელექტრო)",
  fuel: "საწვავი",
  "badge-check": "გალონკა/მზად",
  shield: "ფარანი (დაცვა)",
  star: "ვარსკვლავი",
  clock: "საათი",
  leaf: "ფოთოლი (ეკო)",
  wrench: "ქანჩი (სერვისი)",
};

let cache = null;
let inflight = null;

export function invalidateBenefitCache() {
  cache = null;
  inflight = null;
}

export function useBenefits() {
  const [benefits, setBenefits] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = axios.get(`${API}/benefits`).then((r) => {
        cache = r.data;
        return cache;
      }).catch(() => []);
    }
    inflight.then((d) => setBenefits(d || []));
  }, []);
  return benefits;
}

export function benefitsFor(list, { categoryId, vehicleId } = {}) {
  return (list || [])
    .filter(
      (b) =>
        b.enabled &&
        (b.scope === "all" ||
          (b.scope === "categories" && (b.category_ids || []).includes(categoryId)) ||
          (b.scope === "vehicles" && vehicleId && (b.vehicle_ids || []).includes(vehicleId)))
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
